<div class="d-flex flex-column p-3 bg-light" id="sidenav" style="min-width: 280px; width: 100%">
  <div class="d-flex">
    <a href="/" class="mb-0 me-auto link-dark text-decoration-none">
      <img src="./assets/logo.png" width="75%" />
    </a>
    <button class="btn btn-light" (click)="collapse.toggle()" [attr.aria-expanded]="collapseSidenav" aria-controls="collapsibleSideNav" *ngIf="showSidenavButton">
      <i class="bi bi-list"></i>
    </button>
  </div>
  <div class="flex-column mb-auto collapse flex-nowrap" id="collapsibleSideNav" #collapse="ngbCollapse" [(ngbCollapse)]="collapseSidenav">
    <hr>
    <ul class="nav nav-pills flex-column">
      @if (roleService.isDispatcher() || roleService.isAdmin() || roleService.isDriver()) {
        <li>
          <a class="nav-link" routerLink="/opdrachten" routerLinkActive #rlaJob="routerLinkActive" [ngClass]="rlaJob.isActive ? 'active link-light' : 'link-dark'">
            <i class="bi bi-list-task me-2" width="16" height="16"></i>
            {{ "jobs" | translate }}
          </a>
        </li>
      }
      @if (roleService.isAdmin()) {
        <li>
          <a class="nav-link" routerLink="/producten" routerLinkActive #rlaProduct="routerLinkActive" [ngClass]="rlaProduct.isActive ? 'active link-light' : 'link-dark'">
            <i class="bi bi-tags me-2" width="16" height="16"></i>
            {{ "products" | translate }}
          </a>
        </li>
      }
      <li>
        <a class="nav-link" routerLink="/adresboek" routerLinkActive #rlaContacts="routerLinkActive" [ngClass]="rlaContacts.isActive ? 'active link-light' : 'link-dark'" [routerLinkActiveOptions]="{exact: true}">
          <i class="bi bi-journals me-2" width="16" height="16"></i>
          {{ "address_book" | translate }}
        </a>
      </li>
      @if (roleService.isAdmin()) {
        <li>
          <a class="nav-link" routerLink="/facturen" routerLinkActive #rlaInvoices="routerLinkActive" [ngClass]="rlaInvoices.isActive ? 'active link-light' : 'link-dark'" [routerLinkActiveOptions]="{exact: true}">
            <i class="bi bi-receipt me-2" width="16" height="16"></i>
            {{ "invoices" | translate }}
          </a>
        </li>
        <li>
          <a class="nav-link" routerLink="/creditnotas" routerLinkActive #rlaCreditNotes="routerLinkActive" [ngClass]="rlaCreditNotes.isActive ? 'active link-light' : 'link-dark'" [routerLinkActiveOptions]="{exact: true}">
            <i class="bi bi-receipt-cutoff me-2" width="16" height="16"></i>
            Creditnota's
          </a>
        </li>
      }
      @if (roleService.isAdmin()) {
        <hr>
        <li>
          <div class="ms-3" (click)="configCollapse.toggle()" [attr.aria-expanded]="collapseConfig" [attr.aria-expanded]="collapseConfig">
            <i class="bi bi-sliders me-2"></i>
            <span class="fw-medium">
              {{ "configuration" | translate }}
            </span>
              
            @if (collapseConfig) {
              <i class="bi bi-caret-left float-end"></i>
            } @else {
              <i class="bi bi-caret-down float-end"></i>
            }
          </div>
          <div class="collapse" id="configMenu" #configCollapse="ngbCollapse" [(ngbCollapse)]="collapseConfig">
            <ul class="nav nav-pills flex-column">
              <li class="ms-2">
                <a class="nav-link" routerLink="/configuratie" routerLinkActive #rlaSettings="routerLinkActive" [ngClass]="rlaSettings.isActive ? 'active link-light' : 'link-dark'" [routerLinkActiveOptions]="{exact: true}">
                  <i class="bi bi-gear me-2"></i>
                  {{ "settings" | translate }}
                </a>
              </li>
              <li class="ms-2">
                <a class="nav-link" routerLink="/configuratie/documenten" routerLinkActive #rlaDocuments="routerLinkActive" [ngClass]="rlaDocuments.isActive ? 'active link-light' : 'link-dark'">
                  <i class="bi bi-archive me-2"></i>
                  {{ "documents" | translate }}
                </a>
              </li>
              <li class="ms-2">
                <a class="nav-link" routerLink="/configuratie/contact-types" routerLinkActive #rlaContactTypes="routerLinkActive" [ngClass]="rlaContactTypes.isActive ? 'active link-light' : 'link-dark'">
                  <i class="bi bi-person-rolodex me-2"></i>
                  {{ "contact_types" | translate }}
                </a>
              </li>
              <li class="ms-2">
                <a class="nav-link" routerLink="/gebruikers" routerLinkActive #rlaUsers="routerLinkActive" [ngClass]="rlaUsers.isActive ? 'active link-light' : 'link-dark'" [routerLinkActiveOptions]="{exact: true}">
                  <i class="bi bi-card-checklist me-2"></i>
                  {{ "users" | translate }}
                </a>
              </li>
              <li class="ms-2">
                <a class="nav-link" routerLink="/statistieken" routerLinkActive #rlaStatistics="routerLinkActive" [ngClass]="rlaStatistics.isActive ? 'active link-light' : 'link-dark'" [routerLinkActiveOptions]="{exact: true}">
                  <i class="bi bi-bar-chart me-2"></i>
                  {{ "statistics" | translate }}
                </a>
              </li>
            </ul>
          </div>
        </li>
      }
      <hr>
      <li>
        <div class="ms-3" (click)="userCollapse.toggle()" [attr.aria-expanded]="collapseUserMenu" [attr.aria-expanded]="collapseUserMenu">
          <i class="bi bi-person-circle me-2"></i>
          <span class="fw-medium">
            {{ currentUser.name + ' ' + currentUser.surname }} 
          </span>
            
          @if (collapseUserMenu) {
            <i class="bi bi-caret-left float-end"></i>
          } @else {
            <i class="bi bi-caret-down float-end"></i>
          }
        </div>
        <div class="collapse" id="userMenu" #userCollapse="ngbCollapse" [(ngbCollapse)]="collapseUserMenu">
          <ul class="nav nav-pills flex-column">
            <li class="ms-2">
              <a class="nav-link" routerLinkActive #rlaChangePassword="routerLinkActive" [ngClass]="rlaChangePassword.isActive ? 'active link-light' : 'link-dark'" routerLink="/gebruikers/wachtwoord-wijzigen" [routerLinkActiveOptions]="{exact: true}">
                <i class="bi bi-key me-2"></i>
                {{ "change_password" | translate }}
              </a>
            </li>   
            <li class="ms-2">
              <a class="nav-link link-dark" routerLink="/logout">
                <i class="bi bi-box-arrow-left me-2"></i>
                {{ "logout" | translate }}
              </a>
            </li>            
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
